import React from "react";
import styles from "./SetupPromptModal.module.scss";
import { CloseIcon } from "../../../assets/icons";

interface SetupPromptModalProps {
	icon: React.ReactNode;
	badge: string;
	title: React.ReactNode;
	description: string;
	ctaText: string;
	onCta: () => void;
	onClose: () => void;
	/** Optional decorative background rendered behind the card content. */
	background?: React.ReactNode;
}

/**
 * Shared "purple setup card" prompt modal: a centered card (icon, badge, title,
 * description, CTA) with a circular close button below it. Presentation-only —
 * the consumer supplies the content and handlers.
 */
export const SetupPromptModal: React.FC<SetupPromptModalProps> = ({
	icon,
	badge,
	title,
	description,
	ctaText,
	onCta,
	onClose,
	background,
}) => {
	return (
		<div className={styles.overlay} onClick={onClose}>
			<div className={styles.container} onClick={e => e.stopPropagation()}>
				<div className={styles.modal}>
					{background && <div className={styles.bgPattern}>{background}</div>}
					<div className={styles.iconWrap}>{icon}</div>
					<div className={styles.badge}>{badge}</div>
					<h2 className={styles.title}>{title}</h2>
					<p className={styles.description}>{description}</p>
					<button className={styles.ctaButton} onClick={onCta}>
						{ctaText}
					</button>
				</div>
				<button className={styles.closeButton} onClick={onClose} aria-label="Close">
					<CloseIcon />
				</button>
			</div>
		</div>
	);
};

export default SetupPromptModal;
